import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from '../header';
import Footer from '../footer';
import templepro1 from '../../images/New_Pro_imgs/moov-pro1.webp';
import gemspro1 from '../../images/New_Pro_imgs/gems1.webp';
import FADB from '../../images/New_Pro_imgs/Abudhabibank-1.webp';
import ICESCO from '../../images/New_Pro_imgs/ICESCO-1.webp';
import './projects.css';
import Emirati from '../../images/emirati-school.webp';
import img1 from '../../images/New_Pro_imgs/atlantis-explorer-kids-club.webp';
import img4 from '../../images/New_Pro_imgs/atlantis-1.jpg';
import img5 from '../../images/New_Pro_imgs/atlantis-2.jpg';
import img6 from '../../images/New_Pro_imgs/atlantis-3.webp';
import img7 from '../../images/New_Pro_imgs/atlantis-4.webp';
import img8 from '../../images/New_Pro_imgs/atlantis-5.webp';


function Projects() {
    const [showAbout, setShowAbout] = useState(false);
    const [showMore, setShowMore] = useState(false);

    const allImages = [
        img1,
        img4,
        img5,
        img6,
        img7,
        img8
    ];
    const [currentIndex, setCurrentIndex] = useState(0);

    return (

        <>
            <div className="boxed_wrapper" id="project">
                <Helmet>
                    <title>Theme Park Acoustic Projects</title>
                    <meta name="description" content="Explore theme park acoustic projects with expert acoustic design and soundproofing solutions for immersive entertainment spaces." />
                    <meta property="og:title" content="Our Recently Completed Acoustic Projects" />
                    <meta property="og:description" content="" />
                    <meta property="og:image" content="../../images/moovgroup-office.webp" />
                    <link rel="canonical" href="https://www.moovgroup.com/projects-v6" />
                    <link rel="alternate" href="https://www.moovgroup.com/projects-v6" hreflang="en-GB" />
                </Helmet>
                <Header />
                <div id="moov">
                    <section className="breadcrumb-section projects-bg">
                        <div className="container">
                            <span className="page-tag">Recently</span>
                            <h1 className="page-title">Completed Projects</h1>
                        </div>
                    </section>

                    <section className="portfolio-section section-gap" id="portfolio">
                        <div className="container">
                            <div className="portfolio-items">
                                <div className="portfolio-item portfolio-style-four mb-5">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="portfolio-desc" style={{ marginBottom: "10px" }}>
                                                <span className="count">41.</span>
                                                <span className="line" style={{ margin: "0px 0px 0px 0px" }}></span>
                                                <h5 className="title"><Link to="/">Atlantis Explorer Kid's Club at Atlantis The Royal, Dubai</Link></h5>
                                                <p><b>Location:</b> The Palm Jumeirah, Dubai, UAE</p>
                                                <p><b>Client:</b> Atlantis The Royal</p>
                                                <p><b>Main Contractor:</b> KOJ Interiors</p>
                                                <p><b>Sub Contractor:</b> MOOV Group</p>
                                                <span className="completed-date mb-0 mt-2">About</span>
                                                <p className="about-content">Atlantis Explorer Kid's Club at Atlantis The Royal, Dubai, is a world-class children's entertainment and learning destination featuring interactive gaming environments, creative learning spaces, arts and crafts studios, themed toddler zones, and immersive recreational areas.
                                                    {!showAbout && (
                                                        <span
                                                            className="read-more-btn"
                                                            onClick={() => setShowAbout(true)}
                                                            style={{
                                                                color: "#007bff",
                                                                cursor: "pointer",
                                                                fontWeight: "600",
                                                                marginLeft: "5px"
                                                            }}
                                                        >
                                                            Read More
                                                        </span>
                                                    )}
                                                    {showAbout && (
                                                        <>
                                                            As part of the interior fit-out works executed by KOJ Interiors, MOOV Group was entrusted with the supply and installation of specialized acoustic solutions designed to enhance occupant comfort and optimize acoustic performance throughout the facility.
                                                            <span
                                                                className="read-less-btn"
                                                                onClick={() => setShowAbout(false)}
                                                                style={{
                                                                    color: "#007bff",
                                                                    cursor: "pointer",
                                                                    fontWeight: "600",
                                                                    marginLeft: "5px"
                                                                }}
                                                            >
                                                                Read Less
                                                            </span>
                                                        </>
                                                    )}
                                                </p>

                                                <span className="completed-date mb-0 mt-2">Scope</span>
                                                <p className="scope-content">The acoustic works incorporated Seamless Acoustic Plaster, Wood Wool Acoustic Ceiling Panels, Circular Wood Wool Acoustic Ceiling Clouds, D'ecopanel Acoustic Panels, Circular Melamine Foam Panels, and Seamless Acoustic Plaster Systems across key activity zones to enhance sound absorption, reverberation control, and acoustic comfort.
                                                    {!showMore && (
                                                        <>
                                                            {" "}
                                                            <span
                                                                className="read-more-btn"
                                                                onClick={() => setShowMore(true)}
                                                                style={{
                                                                    color: "#007bff",
                                                                    cursor: "pointer",
                                                                    fontWeight: "600"
                                                                }}
                                                            >
                                                                Read More
                                                            </span>
                                                        </>
                                                    )}
                                                    {showMore && (
                                                        <>
                                                            <br />
                                                            <br />
                                                            Seamless Acoustic Plaster, was installed within the Reception & Craft Station, Art Studio, and Toddler Village Play Area, while Wood Wool Acoustic Ceiling Panels were utilized within the Active Station and Teen Gaming Lounge. The Teen Gaming Lounge featured a complete Wood Wool Acoustic Ceiling System, and the Gaming Station with  Circular Wood Wool Acoustic Ceiling Clouds to effectively manage sound reflections and reverberation within the high-activity gaming environment.

                                                            <br />
                                                            <br />

                                                            Custom-shaped D'ecopanel Acoustic Panels, featuring trees, fences, flowers, animals, were integrated within the Toddler Village and Toddler Play Areas, combining acoustic performance with creative aesthetics. Circular Melamine Foam Panels were also incorporated within selected zones to further improve acoustic comfort.

                                                            <br />
                                                            <br />

                                                            Carefully coordinated with the themed interiors, the acoustic treatments created engaging, visually appealing, and acoustically balanced environments for learning, play, and interaction.

                                                            {" "}
                                                            <span
                                                                className="read-less-btn"
                                                                onClick={() => setShowMore(false)}
                                                                style={{
                                                                    color: "#007bff",
                                                                    cursor: "pointer",
                                                                    fontWeight: "600"
                                                                }}
                                                            >
                                                                Read Less
                                                            </span>
                                                        </>
                                                    )}
                                                </p>
                                                <Link to="/gurm-villa" className="portfolio-link">Project Details <span className="icon">+</span></Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 mt-3">
                                            <div className="portfolio-thumb">
                                                <img src={FADB} alt="Gurm villa" />
                                            </div>
                                            <div className="gallery images">
                                                <div
                                                    className="atlantis-img1"
                                                    style={{
                                                        backgroundImage: `url(${allImages[currentIndex]})`
                                                    }}
                                                >
                                                    <button
                                                        className="gallery-prev"
                                                        onClick={() =>
                                                            setCurrentIndex(
                                                                currentIndex === 0
                                                                    ? allImages.length - 1
                                                                    : currentIndex - 1
                                                            )
                                                        }
                                                    >
                                                        ❮
                                                    </button>

                                                    <button
                                                        className="gallery-next"
                                                        onClick={() =>
                                                            setCurrentIndex(
                                                                currentIndex === allImages.length - 1
                                                                    ? 0
                                                                    : currentIndex + 1
                                                            )
                                                        }
                                                    >
                                                        ❯
                                                    </button>
                                                </div>
                                                <div className="img-bot">
                                                    <div className="atlantis-img2"></div>
                                                    <div className="atlantis-img3"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="portfolio-item portfolio-style-four mb-5">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-6 col-md-6 mt-3">
                                            <div className="portfolio-thumb">
                                                <img src={ICESCO} alt="ICESCO" />
                                            </div>
                                            <div className="gallery images">
                                                <div className="ICESCO-img1"></div>
                                                <div className="img-bot">
                                                    <div className="ICESCO-img2"></div>
                                                    <div className="ICESCO-img3"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="portfolio-desc" style={{ marginBottom: "10px" }}>
                                                <span className="count">40.</span>
                                                <span className="line" style={{ margin: "0px 0px 0px 0px" }}></span>
                                                <h5 className="title"><Link to="/project-icesco">ICESCO - Islamic World Educational Scientific and Cultural Organization</Link></h5>
                                                <p><b>Location:</b> University City, Sharjah</p>
                                                <p><b>Client:</b> Initiatives Implementation Authority</p>
                                                <p><b>Consultant:</b> Emirates Stone Ltd. Co. Fix</p>
                                                <p><b>Main Contractor:</b> Shades Interior LLC</p>
                                                <span className="completed-date mb-0 mt-2">About</span>
                                                <p className="about-content">The Islamic World Educational, Scientific, and Cultural Organization (ICESCO) is a distinguished institution dedicated to advancing education, science, and culture within the Islamic world.</p>
                                                <span className="completed-date mb-0 mt-2">Scope</span>
                                                <p className="scope-content">The scope included specialized installations to address both functional and aesthetic needs across three key spaces: the Auditorium, Recording Studio, and Boardroom. This encompassed wall and ceiling soundproofing for the Auditorium and Recording Studio, Fabriwall installations on the Auditorium walls and ceiling as well as the Boardroom walls, Decopanel works for the Recording Studio and Boardroom walls, and the incorporation of acoustic doors in all three areas.</p>
                                                <Link to="/project-icesco" className="portfolio-link">Project Details <span className="icon">+</span></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="portfolio-item portfolio-style-four mb-5">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="portfolio-desc" style={{ marginBottom: "10px" }}>
                                                <span className="count">39.</span>
                                                <span className="line" style={{ margin: "0px 0px 0px 0px" }}></span>
                                                <h5 className="title"><Link to="/gurm-villa">Al Gurm Private villa</Link></h5>
                                                <p><b>Location:</b> Abudhabi</p>
                                                <p><b>Client:</b> Al Gurm Private villa</p>
                                                <p><b>Architect:</b> Fibrex Construction Group</p>
                                                <p><b>Main Contractor:</b> Fibrex Construction Group</p>
                                                <span className="completed-date mb-0 mt-2">About</span>
                                                <p className="about-content">Moov Group is committed to crafting a personalized and unparalleled home theatre experience. With meticulous attention to detail, we transform the space into a luxurious entertainment haven, perfectly suited for enjoying movies, music, and more. Our advanced acoustic treatments ensure flawless sound clarity and immersive audio performance, tailored to complement the villa’s elegance.</p>
                                                <span className="completed-date mb-0 mt-2">Scope</span>
                                                <p className="scope-content">We enhanced the home cinema of Al Gurm Private villa, with superior soundproofing, acoustic fabric walls and ceilings, star lighting, carpet flooring, decorative lights, premium theatre seating, advanced AV systems, and full system automation—crafting a seamless and luxurious home theatre experience.</p>
                                                <Link to="/gurm-villa" className="portfolio-link">Project Details <span className="icon">+</span></Link>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 mt-3">
                                            <div className="portfolio-thumb">
                                                <img src={FADB} alt="Gurm villa" />
                                            </div>
                                            <div className="gallery images">
                                                <div className="gurmvilla-img1"></div>
                                                <div className="img-bot">
                                                    <div className="gurmvilla-img2"></div>
                                                    <div className="gurmvilla-img3"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="portfolio-item portfolio-style-four mb-5">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-6 col-md-6 mt-3">
                                            <div className="portfolio-thumb">
                                                <img src={templepro1} alt="temple project" />
                                            </div>
                                            <div className="gallery images">
                                                <div className="temple-pro1"></div>
                                                <div className="img-bot">
                                                    <div className="temple-pro2"></div>
                                                    <div className="temple-pro3"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="portfolio-desc" style={{ marginBottom: "10px" }}>
                                                <span className="count">38.</span>
                                                <span className="line" style={{ margin: "0px 0px 0px 0px" }}></span>
                                                <h5 className="title"><Link to="/mandir">BAPS Hindu Mandir, Abu Dhabi</Link></h5>
                                                <p><b>Location:</b> Abu Dhabi</p>
                                                <p><b>Client:</b> MANDIR</p>
                                                <span className="completed-date mb-0 mt-2">About</span>
                                                <p className="about-content"> Built across to the shilpa shastras, the ancient Hindu treatises of mandir construction, the BAPS Hindu
                                                    Mandir in Abu Dhabi is the largest Hindu temple in West Asia and the first traditional hindu stone
                                                    mandir in the Middle East. The mandir stands at 108 feet in height, 262 feet in length, and 180 feet in
                                                    width.</p>
                                                <span className="completed-date mb-0 mt-2">Scope</span>
                                                <p className="scope-content">Supply and Installation of FABRIWALL system and ACOUSTIC BAFFLES.</p>
                                                <Link to="/emarati-school-acoustics" className="portfolio-link">Project Details <span className="icon">+</span></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span className="line-footer1"></span>
                                <div className="portfolio-item portfolio-style-four mb-5">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 order-md-2 mt-4">
                                            <div className="portfolio-thumb">
                                                <img src={gemspro1} alt="temple project" />
                                            </div>

                                            <div className="gallery images">
                                                <div className="gems-pro1"></div>
                                                <div className="img-bot">
                                                    <div className="gems-pro2"></div>
                                                    <div className="gems-pro3"></div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-lg-6 col-md-6 mt-2">
                                            <div className="portfolio-desc">
                                                <span className="count">37.</span>
                                                <span className="line"></span>
                                                <h5 className="title"><Link to="/gems-founders-scl">Gems Founders School</Link></h5>
                                                <p><b>Location:</b> Dubai, UAE</p>
                                                <p><b>Client:</b> Gems Education</p>
                                                <span className="completed-date mb-0 mt-2">About</span>
                                                <p className="about-content">The GEMS Education Core Values are our collective beliefs. They set the standard that we
                                                    expect from all GEMS Education people– from employees and teachers, to parents and
                                                    students.</p>
                                                <span className="completed-date mb-0 mt-2">Scope</span>
                                                <p className="scope-content"> Supply and Installation of
                                                    Acoustic ceiling baffles, Acoustic
                                                    wall panels for multipurpose hall,
                                                    dance & music rooms.</p>
                                                <Link to="/vox-cinema-acoustics" className="portfolio-link">Project Details <span className="icon">+</span></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <span className="line-footer1"></span>
                                <div className="portfolio-item portfolio-style-four mb-5">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 mt-4">
                                            <div className="portfolio-thumb">
                                                <img src={Emirati} alt="Emirati School" />
                                            </div>
                                            <div className="gallery images">
                                                <div className="emarati-img"></div>
                                                <div className="img-bot">
                                                    <div className="emarati-img2"></div>
                                                    <div className="emarati-img3"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 mt-2">
                                            <div className="portfolio-desc">
                                                <span className="count">36.</span>
                                                <span className="line"></span>
                                                <h5 className="title"><Link to="/emarati-school-acoustics">Emarati Schools</Link></h5>
                                                <p><b>Location:</b> Abu Dhabi</p>
                                                <p><b>Client:</b> Presidential Courts</p>
                                                <span className="completed-date mb-0 mt-2">About</span>
                                                <p className="about-content">The Emirates Private School-Abu Dhabi, since its inception in 1982 has been to impart education to all children of our society. To achieve this, we solicit the support of parents, teachers and students so as to make a consistent effort to achieve our aspiration.</p>
                                                <span className="completed-date mb-0 mt-2">Scope</span>
                                                <p className="scope-content">Auditorium Acoustics Works</p>
                                                <Link to="/emarati-school-acoustics" className="portfolio-link">Project Details <span className="icon">+</span></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="portfolio-items">
                                    <div className="portfolio-item portfolio-style-four">
                                        <span className="line-footer"></span>
                                        <div className="row align-items-center">
                                            <div className="col-lg-6 col-md-6">
                                                <Link to="/projects-v7" className="portfolio-next">Next &raquo;</Link>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="portfolio-container2">

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Projects;